/**
 * 금액 표기 헬퍼.
 *
 * buildRegionPageProps와 getRegionFaqs가 둘 다 이 함수를 쓰는데, 서로를 import하면
 * 순환 참조가 되어 런타임에 함수가 undefined가 된다(getStaticProps가 던지고 페이지가 404).
 * 그래서 의존성 없는 별도 모듈로 둔다. 여기서는 아무것도 import하지 않는다.
 */

/**
 * 원 단위 금액을 만원 단위 라벨로. 50000 -> "5만원"
 *
 * undefined와 NaN도 null로 취급한다. 타입은 number | null이지만 prop 배선이 어긋나면
 * undefined가 들어오고, 그때 Math.round(undefined / 10000)이 NaN이 되어 화면에
 * "NaN만원"이 그대로 노출된다. 금액은 고객이 판단 근거로 쓰는 값이라 조용히 깨지면 안 된다.
 * 값이 없으면 null을 반환해 호출부가 "문의" 같은 대체 표기를 쓰게 한다.
 */
export function toManwon(value: number | null | undefined): string | null {
  if (typeof value !== "number" || !Number.isFinite(value)) return null;
  const manwon = Math.round(value / 10000);
  return `${manwon.toLocaleString("ko-KR")}만원`;
}

/**
 * 금액 범위 라벨. 하한과 상한이 같으면 "326만원 ~ 326만원" 대신 단일 값으로 접는다.
 * 장례식장이 1곳인 지역이나 요금이 균일한 지역에서 그 형태가 실제로 나온다.
 */
export function toManwonRange(
  min: number | null | undefined,
  max: number | null | undefined,
): string | null {
  const low = toManwon(min);
  if (!low) return null;
  const high = toManwon(max);
  return high && high !== low ? `${low} ~ ${high}` : low;
}
